export enum SmsHeaderEnum {
  DEFAULT = 'Crise en cours',
  DEMO = 'Démonstration en cours',
  EXERCISE = 'Exercice en cours',
}